import React from "react";
import Card from "./Card";

function App() {
    return <Card/>;
}

export default App;